<template>
  <div class="feature-page">
    <div class="page-header">
    </div>

    <div class="feature-layout">
      <div class="feature-left">
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
            </div>
            <span>AI智能主播贴片</span>
            <label class="header-toggle" style="margin-left: auto;">
              <input type="checkbox" v-model="config.enabled" />
              <span class="toggle-track"></span>
            </label>
            <button class="icon-reset-btn" title="恢复默认" @click="handleResetClick($event, resetAIConfig)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
                <path d="M3 3v5h5"/>
              </svg>
            </button>
          </div>
          <div class="card-body">
            <div class="config-list">
              <div :class="{ disabled: !config.enabled }">
                <div class="config-item">
                  <div class="label-row">
                    <label>自动轮播间隔 (秒)</label>
                    <span class="value-tag">{{ config.rotationIntervalMin }}s - {{ config.rotationIntervalMax }}s</span>
                  </div>
                  <div class="input-with-unit">
                    <input type="number" v-model.number="config.rotationIntervalMin" class="cyber-input-mini" min="1" max="60" />
                    <span class="unit">到</span>
                    <input type="number" v-model.number="config.rotationIntervalMax" class="cyber-input-mini" min="1" max="60" />
                    <span class="unit">秒更换一次</span>
                  </div>
                </div>

                <div class="config-item" style="margin-top: 16px;">
                  <label>贴片文字库 (一行一个)</label>
                  <textarea v-model="config.multiLineText" class="cyber-textarea-mini" rows="4" placeholder="输入贴片文字&#10;一行一个内容..."></textarea>
                </div>

                <div class="config-item" style="margin-top: 16px;">
                  <label>即时贴片发送 (按回车发送)</label>
                  <div class="sticker-send-group">
                    <input type="text" v-model="config.instantText" class="cyber-input-large" placeholder="输入文字立即展示..." @keyup.enter="sendInstantSticker" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="feature-center">
        <div class="standard-phone-frame">
          <div class="standard-phone-screen">
            <canvas
                ref="videoCanvas"
                class="video-element"
                :style="{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        opacity: 1,
                        pointerEvents: 'auto',
                        zIndex: 1
                      }"
            ></canvas>

            <div class="live-ui-overlay">
              <div class="live-header">
                <div class="user-info-capsule">
                  <div class="avatar"><img src="https://api.dicebear.com/7.x/avataaars/svg?seed=Douyin" alt="avatar"></div>
                  <div class="meta">
                    <div class="name">MULTIFACED</div>
                    <div class="stats">12.8w 点赞</div>
                  </div>
                  <div class="follow">+ 关注</div>
                </div>
                <div class="viewer-tag">
                  <span class="val">3821</span>
                  <span class="lab">人</span>
                </div>
              </div>

              <div v-if="config.enabled" class="ai-analysis-layer">
                <div class="ai-target-pos"
                     ref="stickerPreview"
                     :style="{ top: config.stickerY + '%', left: config.stickerX + '%' }"
                     @mousedown="startStickerDrag">
                  <div v-if="instantStickerActive" class="final-sticker-preview">
                    <div class="sticker-anchor-tag"><span class="sep">丨</span>@主播</div>
                    <span class="text">{{ instantStickerValue }}</span>
                  </div>
                  <div v-else class="final-sticker-preview">
                    <div class="sticker-anchor-tag"><span class="sep">丨</span>@主播</div>
                    <span class="text">{{ currentRotationText || '爆款推荐' }}</span>
                  </div>
                </div>
              </div>

<!--              <div class="live-bottom-area">-->
<!--                <div class="comment-gradient"></div>-->
<!--              </div>-->
            </div>


          </div>
        </div>
      </div>

      <div class="feature-right">
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
            </div>
            <span>AI智能回复贴片</span>
            <button class="add-btn-mini" title="新增内容" @click="addNewReplyRule">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              新增
            </button>
            <label class="header-toggle" style="margin-left: 8px;">
              <input type="checkbox" v-model="config.replyEnabled" />
              <span class="toggle-track"></span>
            </label>
            <button class="icon-reset-btn" title="清空全部" @click="clearAllReplies">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              </svg>
            </button>
          </div>
          <div class="card-body">
            <div class="config-list" :class="{ disabled: !config.replyEnabled }">
              <div class="config-item">
                <label>回复模版切换</label>
                <div class="template-grid">
                  <button v-for="tpl in templates" :key="tpl.id" class="tpl-btn" :class="{ active: config.currentTemplate === tpl.id }" @click="handleTemplateChange(tpl.id)">{{ tpl.name }}</button>
                </div>
              </div>
              <div class="reply-table-container">
                <table class="cyber-table">
                  <thead><tr><th width="100">关键词</th><th>回复内容</th><th width="40">操作</th></tr></thead>
                  <tbody>
                  <tr v-for="rule in config.replyKeywords" :key="rule.id" @dblclick="openEditModal(rule)">
                    <td>
                      <div class="kw-tags-group">
                        <span v-for="kw in rule.keyword.split(' ')" :key="kw" class="kw-tag">{{ kw }}</span>
                      </div>
                    </td>
                    <td><div class="reply-content-cell">{{ rule.content }}</div></td>
                    <td><button class="del-btn-icon" @click.stop="removeReplyRule(rule.id)"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"></path></svg></button></td>
                  </tr>
                  <tr v-if="config.replyKeywords.length === 0"><td colspan="3" class="empty-tip">暂无回复规则</td></tr>
                  </tbody>
                </table>
              </div>

              <div v-if="showReplyModal" class="modal-overlay" @click.self="closeReplyModal">
                <div class="cyber-modal">
                  <div class="modal-header">
                    <h3>{{ editingId ? '编辑回复规则' : '新增回复规则' }}</h3>
                    <button class="close-btn" @click="closeReplyModal">×</button>
                  </div>
                  <div class="modal-body">
                    <div class="modal-form-item">
                      <label>关键词 (空格分隔多个)</label>
                      <input type="text" v-model="modalData.keyword" class="cyber-input-large" placeholder="例如: 多少钱 怎么卖 价格" />
                    </div>
                    <div class="modal-form-item" style="margin-top: 20px;">
                      <label>回复内容 (仅限一条)</label>
                      <textarea v-model="modalData.content" class="cyber-textarea-mini" style="min-height: 120px;" placeholder="输入回复话术..."></textarea>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button class="cyber-send-btn" @click="saveReplyRule" style="width: 100%;">确定保存</button>
                  </div>
                </div>
              </div>
              <div class="action-footer">
                <button class="action-btn-outline" @click="triggerImport"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>导入</button>
                <button class="action-btn-outline" @click="exportReplies"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>导出</button>
                <input type="file" ref="fileInputRef" style="display: none" accept=".json" @change="handleImportFile" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmartOverlay',
  inject: ['syncCanvasToTarget', 'globalCanvasState'],
  data() {
    return {
      config: {
        enabled: false,
        rotationIntervalMin: 3,
        rotationIntervalMax: 8,
        instantText: '',
        multiLineText: '爆款推荐\n限时秒杀\n关注领券\n新品上市\n好评如潮',
        replyEnabled: false,
        currentTemplate: 'default',
        stickerX: 70,
        stickerY: 12,
        replyKeywords: [
          { id: 1, keyword: '多少钱', content: '现在下单仅需99元，点击下方购物车领券更优惠！' },
          { id: 2, keyword: '怎么卖', content: '点击左下角小黄车，1号链接就是我们今天的主打款。' }
        ]
      },
      templateData: {
        default: [
          { id: 1, keyword: '多少钱', content: '现在下单仅需99元，点击下方购物车领券更优惠！' },
          { id: 2, keyword: '怎么卖', content: '点击左下角小黄车，1号链接就是我们今天的主打款。' },
          { id: 3, keyword: '有优惠', content: '是的，今天直播间有专属优惠券，满99减10元！' },
          { id: 4, keyword: '质量', content: '您放心，我们的产品都是正品保障，假一赔十！' }
        ],
        promotion: [
          { id: 1, keyword: '今天活动', content: '今天是618大促最后一天，错过今天再等一年！' },
          { id: 2, keyword: '满减', content: '满199减50，满299减80，满399减120，上不封顶！' },
          { id: 3, keyword: '买一送一', content: '是的，今天下单买一送一，库存有限，先到先得！' },
          { id: 4, keyword: '包邮', content: '全国包邮，偏远地区也包邮，48小时内发货！' },
          { id: 5, keyword: '限时', content: '限时秒杀，仅限今天，错过就恢复原价了！' }
        ],
        service: [
          { id: 1, keyword: '客服', content: '点击左上角头像，可以联系我们的在线客服哦！' },
          { id: 2, keyword: '退换货', content: '收到货不满意，7天内无理由退换，运费险已备好！' },
          { id: 3, keyword: '什么时候发货', content: '48小时内发货，我们会尽快为您安排！' },
          { id: 4, keyword: '物流', content: '默认发中通快递，偏远地区发邮政EMS。' },
          { id: 5, keyword: '怎么查', content: '订单详情里可以查看物流信息，或联系客服查询。' }
        ]
      },
      templates: [
        { id: 'default', name: '默认话术' },
        { id: 'promotion', name: '大促模版' },
        { id: 'service', name: '客服引导' }
      ],
      currentRotationText: '爆款推荐',
      instantStickerActive: false,
      instantStickerValue: '',
      rotationTimer: null,
      instantTimer: null,
      showReplyModal: false,
      editingId: null,
      modalData: {
        keyword: '',
        content: ''
      },
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      volume: 1,
      isPageActive: false,
      isInitialSync: false,
      isMuted: true,
      lastDeactivatedTime: 0,
      lastDeactivatedProgress: 0,
      playbackWatchdog: null,
      // Canvas 同步相关
      canvasSyncTimer: null
    }
  },
  computed: {
    videoUrl() {
      const media = this.$store.state.currentMedia
      if (media && media.type === 'video') return media.url
      return null
    },
    isVirtualCameraLive() {
      return this.$store.state.isVirtualCameraLive
    },
    hiddenPlayerStyle() {
      if (this.isVirtualCameraLive) {
        return {
          opacity: 0,
          position: 'absolute',
          zIndex: 1
        }
      }
      return {}
    },
    progressPercent() {
      return this.duration ? (this.currentTime / this.duration) * 100 : 0
    },
    stickerPool() {
      return this.config.multiLineText.split('\n').filter(t => t.trim() !== '')
    }
  },
  watch: {
    'config.enabled'(newVal) {
      if (newVal) {
        this.startRotation()
      } else {
        this.stopRotation()
      }
      this.syncToStore()
    },
    'config.rotationIntervalMin'() {
      this.syncToStore()
    },
    'config.rotationIntervalMax'() {
      this.syncToStore()
    },
    'config.multiLineText'() {
      this.syncToStore()
    },
    'config.stickerX'() {
      this.syncToStore()
    },
    'config.stickerY'() {
      this.syncToStore()
    },
    'config.replyEnabled'() {
      this.syncToStore()
    },
    'config.replyKeywords': {
      deep: true,
      handler() {
        this.syncToStore()
      }
    },
    // 同步 rotation text 到 globalCanvasState
    currentRotationText(newVal) {
      if (this.globalCanvasState && this.globalCanvasState.smartOverlayState) {
        this.globalCanvasState.smartOverlayState.currentRotationText = newVal
      }
    },
    // 同步即时贴片状态到 globalCanvasState
    instantStickerActive(newVal) {
      if (this.globalCanvasState && this.globalCanvasState.smartOverlayState) {
        this.globalCanvasState.smartOverlayState.instantStickerActive = newVal
      }
    },
    instantStickerValue(newVal) {
      if (this.globalCanvasState && this.globalCanvasState.smartOverlayState) {
        this.globalCanvasState.smartOverlayState.instantStickerValue = newVal
      }
    },
    volume(newVal) {
      if (this.$refs.videoPlayerRef) {
        this.$refs.videoPlayerRef.volume = newVal
      }
    },
    isMuted(newVal) {
      if (this.$refs.videoPlayerRef) {
        this.$refs.videoPlayerRef.muted = newVal
      }
    },
    '$store.state.currentMedia': {
      deep: true,
      handler(newMedia) {
        if (!this.isPageActive || !newMedia || !newMedia.url) return

        if (this.$refs.videoPlayerRef) {
          if (Math.abs(this.$refs.videoPlayerRef.currentTime - newMedia.currentTime) > 1) {
            this.$refs.videoPlayerRef.currentTime = newMedia.currentTime
            this.currentTime = newMedia.currentTime
          }
          if (newMedia.isPlaying !== this.isPlaying) {
            this.isPlaying = newMedia.isPlaying
            if (this.isPlaying) {
              if (!this.isVirtualCameraLive) {
                this.isMuted = false
                if (this.$refs.videoPlayerRef) this.$refs.videoPlayerRef.muted = false
              }
              this.$refs.videoPlayerRef.play().catch((err) => {
                console.warn('[SmartOverlay] 自动播放失败:', err)
              })
            } else {
              this.$refs.videoPlayerRef.pause()
            }
          }
        }
      }
    }
  },
  mounted() {
    const storeConfig = this.$store.state.smartOverlayParams
    if (storeConfig) {
      this.config = { ...this.config, ...storeConfig }
      // 如果 store 中有当前模板，用对应模板的数据初始化
      if (this.templateData[this.config.currentTemplate]) {
        this.config.replyKeywords = JSON.parse(JSON.stringify(this.templateData[this.config.currentTemplate]))
      }
    } else {
      // 如果 store 中没有数据，用默认模板初始化
      this.config.replyKeywords = JSON.parse(JSON.stringify(this.templateData.default))
    }
    
    // 初始化 globalCanvasState
    if (this.globalCanvasState && this.globalCanvasState.smartOverlayState) {
      this.globalCanvasState.smartOverlayState.currentRotationText = this.currentRotationText
      this.globalCanvasState.smartOverlayState.instantStickerActive = this.instantStickerActive
      this.globalCanvasState.smartOverlayState.instantStickerValue = this.instantStickerValue
    }


    this.isPageActive = true
    this.isInitialSync = true
    this.isMuted = true

    // 初始化 globalCanvasState
    if (this.globalCanvasState && this.globalCanvasState.smartOverlayState) {
      this.globalCanvasState.smartOverlayState.currentRotationText = this.currentRotationText
      this.globalCanvasState.smartOverlayState.instantStickerActive = this.instantStickerActive
      this.globalCanvasState.smartOverlayState.instantStickerValue = this.instantStickerValue
    }

    if (this.config.enabled) {
      this.startRotation()
    }

    const media = this.$store.state.currentMedia
    if (media) {
      this.isPlaying = media.isPlaying
      this.currentTime = media.currentTime
    }

    this.$nextTick(() => {
      this.performSync()
      this.startCanvasSync()
      this.isInitialSync = false
      this.syncToStore()
    })
  },
  beforeDestroy() {
   /* this.stopRotation()
    this.stopPlaybackWatchdog()
    this.stopCanvasSync()*/
  },
  activated() {

  },
  deactivated() {
   /* this.isPageActive = false
    this.stopRotation()
    this.stopPlaybackWatchdog()
    this.stopCanvasSync()

    if (this.$refs.videoPlayerRef) {
      const currentTimeToSave = this.$refs.videoPlayerRef.currentTime
      this.lastDeactivatedTime = Date.now()
      this.lastDeactivatedProgress = currentTimeToSave

      this.$store.commit('UPDATE_MEDIA_STATE', {
        currentTime: currentTimeToSave,
        isPlaying: this.isPlaying
      })

      if (!this.isVirtualCameraLive) {
        this.$refs.videoPlayerRef.pause()
        this.isMuted = true
      }
    }*/
  },
  methods: {
    startStickerDrag(e) {
      const rect = e.currentTarget.parentElement.getBoundingClientRect()
      const startX = e.clientX
      const startY = e.clientY
      const initialX = this.config.stickerX
      const initialY = this.config.stickerY

      const onMouseMove = (moveEvent) => {
        const deltaX = ((moveEvent.clientX - startX) / rect.width) * 100
        const deltaY = ((moveEvent.clientY - startY) / rect.height) * 100
        this.config.stickerX = Math.max(0, Math.min(85, initialX + deltaX))
        this.config.stickerY = Math.max(0, Math.min(95, initialY + deltaY))
      }

      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove)
        document.removeEventListener('mouseup', onMouseUp)
      }

      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
    },

    handleTemplateChange(templateId) {
      // 如果当前模板与目标模板相同，则不执行任何操作
      if (templateId === this.config.currentTemplate) return

      // 检查当前关键词列表是否已修改
      const originalKeywords = JSON.stringify(this.templateData[this.config.currentTemplate])
      const currentKeywords = JSON.stringify(this.config.replyKeywords)

      // 如果有修改，先询问用户确认
      if (originalKeywords !== currentKeywords && this.config.replyKeywords.length > 0) {
        const confirmed = confirm('切换模板会覆盖当前的回复规则，是否继续？')
        if (!confirmed) return
      }

      // 更新当前模板
      this.config.currentTemplate = templateId

      // 更新关键词列表
      if (this.templateData[templateId]) {
        this.config.replyKeywords = JSON.parse(JSON.stringify(this.templateData[templateId]))
      }

      this.syncToStore()
    },

    // 启动 canvas 同步
    startCanvasSync() {
      this.stopCanvasSync()
      if (!this.syncCanvasToTarget || !this.$refs.videoCanvas) return

      const sync = () => {
        if (this.syncCanvasToTarget && this.$refs.videoCanvas) {
          this.syncCanvasToTarget(this.$refs.videoCanvas)
        }
      }

      // 立即同步一次
      sync()

      // 每 30ms 同步一次，约 33fps
      this.canvasSyncTimer = setInterval(sync, 30)
    },

    // 停止 canvas 同步
    stopCanvasSync() {
      if (this.canvasSyncTimer) {
        clearInterval(this.canvasSyncTimer)
        this.canvasSyncTimer = null
      }
    },

    startRotation() {
      this.stopRotation()
      if (!this.config.enabled || this.stickerPool.length <= 1) return

      const rotate = () => {
        const currentIndex = this.stickerPool.indexOf(this.currentRotationText)
        const nextIndex = (currentIndex + 1) % this.stickerPool.length
        this.currentRotationText = this.stickerPool[nextIndex]

        const min = Math.min(this.config.rotationIntervalMin, this.config.rotationIntervalMax)
        const max = Math.max(this.config.rotationIntervalMin, this.config.rotationIntervalMax)
        const nextInterval = Math.floor(Math.random() * (max - min + 1) + min)

        this.rotationTimer = setTimeout(rotate, nextInterval * 1000)
      }

      const initialMin = Math.min(this.config.rotationIntervalMin, this.config.rotationIntervalMax)
      const initialMax = Math.max(this.config.rotationIntervalMin, this.config.rotationIntervalMax)
      const initialInterval = Math.floor(Math.random() * (initialMax - initialMin + 1) + initialMin)
      this.rotationTimer = setTimeout(rotate, initialInterval * 1000)
    },

    stopRotation() {
      if (this.rotationTimer) {
        clearTimeout(this.rotationTimer)
        this.rotationTimer = null
      }
    },

    sendInstantSticker() {
      if (!this.config.instantText.trim()) return
      this.instantStickerValue = this.config.instantText
      this.instantStickerActive = true
      this.config.instantText = ''
      if (this.instantTimer) clearTimeout(this.instantTimer)
      this.instantTimer = setTimeout(() => {
        this.instantStickerActive = false
      }, 3000)
    },

    openEditModal(rule) {
      this.editingId = rule.id
      this.modalData.keyword = rule.keyword
      this.modalData.content = rule.content
      this.showReplyModal = true
    },

    addNewReplyRule() {
      this.editingId = null
      this.modalData.keyword = ''
      this.modalData.content = ''
      this.showReplyModal = true
    },

    closeReplyModal() {
      this.showReplyModal = false
      this.editingId = null
    },

    saveReplyRule() {
      if (!this.modalData.keyword.trim() || !this.modalData.content.trim()) {
        alert('请填写完整关键词和回复内容')
        return
      }

      if (this.editingId) {
        const index = this.config.replyKeywords.findIndex(r => r.id === this.editingId)
        if (index !== -1) {
          this.$set(this.config.replyKeywords, index, {
            ...this.config.replyKeywords[index],
            keyword: this.modalData.keyword.trim(),
            content: this.modalData.content.trim()
          })
        }
      } else {
        const newId = this.config.replyKeywords.length > 0
            ? Math.max(...this.config.replyKeywords.map(r => r.id)) + 1
            : 1
        this.config.replyKeywords.push({
          id: newId,
          keyword: this.modalData.keyword.trim(),
          content: this.modalData.content.trim()
        })
      }
      this.closeReplyModal()
    },

    removeReplyRule(id) {
      if (confirm('确定要删除这条规则吗？')) {
        this.config.replyKeywords = this.config.replyKeywords.filter(r => r.id !== id)
      }
    },

    clearAllReplies() {
      if (confirm('确定要清空所有回复内容吗？')) {
        this.config.replyKeywords = []
      }
    },

    triggerImport() {
      this.$refs.fileInputRef.click()
    },

    handleImportFile(event) {
      const input = event.target
      if (!input.files || input.files.length === 0) return

      const file = input.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        try {
          const content = e.target.result
          const data = JSON.parse(content)

          if (Array.isArray(data)) {
            const isValid = data.every(item => item.keyword && item.content)
            if (isValid) {
              const startId = this.config.replyKeywords.length > 0
                  ? Math.max(...this.config.replyKeywords.map(r => r.id)) + 1
                  : 1

              const formattedData = data.map((item, index) => ({
                id: startId + index,
                keyword: item.keyword,
                content: item.content
              }))

              this.config.replyKeywords = [...this.config.replyKeywords, ...formattedData]
              alert(`成功导入 ${formattedData.length} 条回复规则`)
            } else {
              alert('导入失败：文件格式不正确，缺少 keyword 或 content 字段')
            }
          } else {
            alert('导入失败：JSON 数据应为数组格式')
          }
        } catch (err) {
          alert('导入失败：无法解析 JSON 文件')
        } finally {
          input.value = ''
        }
      }

      reader.readAsText(file)
    },

    exportReplies() {
      if (this.config.replyKeywords.length === 0) {
        alert('当前没有可导出的数据')
        return
      }
      const data = JSON.stringify(this.config.replyKeywords, null, 2)
      const blob = new Blob([data], { type: 'application/json' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `AI智能回复_${Date.now()}.json`
      link.click()
      URL.revokeObjectURL(url)
    },

    startPlaybackWatchdog() {
      if (this.playbackWatchdog) clearInterval(this.playbackWatchdog)
      this.playbackWatchdog = setInterval(() => {
        if (this.isPageActive && this.isPlaying && this.$refs.videoPlayerRef) {
          if (this.$refs.videoPlayerRef.paused) {
            console.log('[SmartOverlay] 监视器补救：正在尝试恢复播放...')
            this.$refs.videoPlayerRef.play().catch(() => {
              if (this.$refs.videoPlayerRef) {
                this.$refs.videoPlayerRef.muted = true
                this.$refs.videoPlayerRef.play().catch(() => {})
              }
            })
          }
        }
      }, 500)
    },

    stopPlaybackWatchdog() {
      if (this.playbackWatchdog) {
        clearInterval(this.playbackWatchdog)
        this.playbackWatchdog = null
      }
    },

    syncToStore() {
      if (!this.isPageActive || this.isInitialSync) return
      this.$store.commit('UPDATE_SMART_OVERLAY_PARAMS', this.config)

      const globalMedia = this.$store.state.currentMedia
      if (globalMedia && this.$refs.videoPlayerRef) {
        if (this.$refs.videoPlayerRef.currentTime === 0 && (globalMedia.currentTime || 0) > 0) return
        this.$store.commit('UPDATE_MEDIA_STATE', {
          currentTime: this.$refs.videoPlayerRef.currentTime,
          isPlaying: this.isPlaying
        })
      }
    },

    togglePlayback() {
      if (!this.$refs.videoPlayerRef) return
      if (this.isPlaying) {
        this.$refs.videoPlayerRef.pause()
      } else {
        this.$refs.videoPlayerRef.play()
      }
      this.syncToStore()
    },

    formatTime(seconds) {
      const m = Math.floor(seconds / 60)
      const s = Math.floor(seconds % 60)
      return `${m}:${s.toString().padStart(2, '0')}`
    },

    onPlayerPlay() {
      this.isPlaying = true
      this.syncToStore()
    },

    onPlayerPause() {
      this.isPlaying = false
      this.syncToStore()
    },

    onPlayerTimeUpdate() {
      if (this.$refs.videoPlayerRef && !this.isInitialSync) {
        this.currentTime = this.$refs.videoPlayerRef.currentTime
        if (Math.floor(this.currentTime) !== Math.floor(this.$store.state.currentMedia?.currentTime || 0)) {
          this.syncToStore()
        }
      }
    },

    onPlayerLoadedMetadata() {
      if (this.$refs.videoPlayerRef) {
        this.duration = this.$refs.videoPlayerRef.duration
        this.$refs.videoPlayerRef.volume = 1
      }
    },

    onVideoEnded() {
      this.isPlaying = false
      this.currentTime = 0
      this.syncToStore()
    },

    onPlayerError(e) {
      const video = e.target
      if (!video.src || video.src.endsWith('/smart-overlay')) return

      console.error('[SmartOverlay] 播放器错误:', {
        code: video.error?.code,
        message: video.error?.message,
        src: video.src
      })

      if (this.$refs.videoPlayerRef && this.isPageActive) {
        console.log('[SmartOverlay] 正在尝试自动恢复视频流...')
        setTimeout(() => {
          if (this.$refs.videoPlayerRef && this.isPageActive) {
            this.$refs.videoPlayerRef.load()
            if (this.isPlaying) this.$refs.videoPlayerRef.play().catch(() => {})
          }
        }, 1500)
      }
    },

    onStreamError() {
      if (!this.isVirtualCameraLive) return
      console.warn('[SmartOverlay] 推流预览加载失败')
    },

    startSeek(e) {
      const bar = e.currentTarget
      const updateProgress = (ex) => {
        const rect = bar.getBoundingClientRect()
        const pos = Math.max(0, Math.min(1, (ex.clientX - rect.left) / rect.width))
        if (this.$refs.videoPlayerRef) this.$refs.videoPlayerRef.currentTime = pos * this.duration
      }
      updateProgress(e)
      const onMouseMove = (moveEvent) => updateProgress(moveEvent)
      const onMouseUp = () => { window.removeEventListener('mousemove', onMouseMove); window.removeEventListener('mouseup', onMouseUp) }
      window.addEventListener('mousemove', onMouseMove); window.addEventListener('mouseup', onMouseUp)
    },

    handleResetClick(e, resetFn) {
      const btn = e.currentTarget
      btn.style.transform = 'rotate(-180deg)'
      resetFn()
      setTimeout(() => { btn.style.transform = '' }, 500)
    },

    resetAIConfig() {
      this.config.enabled = true
      this.config.rotationIntervalMin = 3
      this.config.rotationIntervalMax = 8
      this.config.instantText = ''
      this.config.multiLineText = '爆款推荐\n限时秒杀\n关注领券\n新品上市\n好评如潮'
      this.syncToStore()
    },

    performSync() {
      if (!this.$refs.videoPlayerRef || !this.isPageActive) return
      const currentMedia = this.$store.state.currentMedia
      if (!currentMedia) return

      try {
        let targetTime = currentMedia.currentTime || 0

        if (this.isVirtualCameraLive && currentMedia.isPlaying && this.lastDeactivatedTime > 0) {
          const elapsed = (Date.now() - this.lastDeactivatedTime) / 1000
          const speed = this.$store.state.audioParams?.speed || 1.0
          const compensation = elapsed * speed
          targetTime += compensation
        }

        if (Math.abs(this.$refs.videoPlayerRef.currentTime - targetTime) > 0.5) {
          this.$refs.videoPlayerRef.currentTime = targetTime
        }

        if (currentMedia.isPlaying) {
          if (!this.isVirtualCameraLive) {
            this.$refs.videoPlayerRef.muted = false
            this.$refs.videoPlayerRef.volume = 1
            this.isMuted = false
          }

          this.$refs.videoPlayerRef.play().catch(() => {
            console.warn('[SmartOverlay] 自动播放受阻...')
          })

          this.startPlaybackWatchdog()

          if (!this.isVirtualCameraLive) {
            setTimeout(() => {
              if (this.$refs.videoPlayerRef && this.isPageActive && this.$store.state.currentMedia?.isPlaying) {
                this.isMuted = false
                this.$refs.videoPlayerRef.muted = false
                this.isPlaying = true
                if (Math.abs(this.$refs.videoPlayerRef.currentTime - (this.$store.state.currentMedia?.currentTime || 0)) > 0.5) {
                  this.$refs.videoPlayerRef.currentTime = this.$store.state.currentMedia?.currentTime || 0
                }
              }
            }, 450)
          } else {
            this.isPlaying = true
          }
        } else {
          this.$refs.videoPlayerRef.pause()
          this.isPlaying = false
        }
      } catch (e) {
        console.error('[SmartOverlay] 同步流程异常:', e)
      } finally {
        setTimeout(() => { this.isInitialSync = false }, 500)
      }
    }
  }
}
</script>

<style scoped>
.feature-page { padding: 0; height: 100%; display: flex; flex-direction: column; }
.feature-layout {
  display: grid; grid-template-columns: 370px 1fr 370px; gap: 20px; flex: 1; min-height: 0;
  max-width: 1400px; margin: 0 auto; padding: 0 16px; position: relative; left: -10px;
}
.feature-left, .feature-right { display: flex; flex-direction: column; gap: 16px; margin-top: 5px; }
.panel-card {
  background: rgba(20, 20, 20, 0.6); backdrop-filter: blur(10px); border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px; overflow: hidden; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3), 0 0 20px rgba(0, 212, 255, 0.08);
}
.tech-card { position: relative; }
.tech-card::before {
  content: ''; position: absolute; top: 0; left: 0; right: 0; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.4), transparent);
}
.card-header {
  display: flex; align-items: center; gap: 10px; padding: 12px 14px;
  background: linear-gradient(180deg, #151515 0%, #0f0f0f 100%); border-bottom: 1px solid #2a2a2a;
  color: #b0b0b0; font-size: 12px; font-weight: 600;
}
.card-header span { font-size: 13px; font-weight: 600; color: #fff; flex: 1; }
.icon-wrapper {
  width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;
  background: rgba(0, 212, 255, 0.12); border-radius: 8px; color: #00d4ff;
}
.header-toggle { display: flex; align-items: center; cursor: pointer; position: relative; }
.header-toggle input { position: absolute; inset: 0; opacity: 0; cursor: pointer; }
.toggle-track { width: 44px; height: 22px; background: #2a2a2a; border-radius: 11px; position: relative; transition: all 0.2s; border: 1px solid #3a3a3a; }
.toggle-track::after { content: ''; position: absolute; top: 2px; left: 2px; width: 16px; height: 16px; background: #666; border-radius: 50%; transition: all 0.2s; }
input:checked + .toggle-track { background: #00d4ff; border-color: #00d4ff; }
input:checked + .toggle-track::after { left: 24px; background: #fff; }
.icon-reset-btn { background: none; border: none; color: #666; cursor: pointer; padding: 4px; border-radius: 4px; transition: all 0.3s; margin-left: 4px; }
.icon-reset-btn:hover { color: #00d4ff; background: rgba(0, 212, 255, 0.1); }

.add-btn-mini {
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.3);
  color: #00d4ff;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.3s;
}
.add-btn-mini:hover {
  background: #00d4ff;
  color: #000;
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
}

.card-body { padding: 10px; min-height: 145px; display: flex; flex-direction: column; }
.config-list.disabled { opacity: 0.5; pointer-events: none; }
.template-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin-top: 4px; }
.tpl-btn { background: rgba(255, 255, 255, 0.05); border: 1px solid #333; color: #888; font-size: 11px; padding: 6px; border-radius: 4px; cursor: pointer; }
.tpl-btn.active { background: rgba(0, 212, 255, 0.1); border-color: #00d4ff; color: #00d4ff; }
.reply-table-container { margin-top: 24px; flex: 1; overflow-y: auto; height: 450px; border: 1px solid #333; border-radius: 6px; }
.cyber-table { width: 100%; border-collapse: collapse; font-size: 11px; }
.cyber-table th { background: #1a1a1a; padding: 8px; text-align: left; color: #666; border-bottom: 1px solid #333; }
.cyber-table td { padding: 8px; border-bottom: 1px solid #222; color: #aaa; cursor: pointer; }
.cyber-table tr:hover { background: rgba(255, 255, 255, 0.02); }
.kw-tags-group {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.kw-tag { background: rgba(0, 212, 255, 0.1); color: #00d4ff; padding: 2px 6px; border-radius: 4px; font-size: 10px; border: 1px solid rgba(0, 212, 255, 0.2); }

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.cyber-modal {
  width: 550px;
  background: #151515;
  border: 1px solid #00d4ff;
  border-radius: 12px;
  box-shadow: 0 0 30px rgba(0, 212, 255, 0.2);
  overflow: hidden;
}
.modal-header {
  padding: 16px 20px;
  background: linear-gradient(180deg, #1a1a1a 0%, #151515 100%);
  border-bottom: 1px solid #2a2a2a;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-header h3 { font-size: 16px; color: #fff; margin: 0; font-weight: 600; }
.close-btn { background: none; border: none; color: #666; font-size: 24px; cursor: pointer; transition: color 0.3s; }
.close-btn:hover { color: #fe2c55; }
.modal-body { padding: 24px 20px; }
.modal-form-item label { display: block; color: #888; font-size: 12px; margin-bottom: 8px; }
.modal-footer {
  padding: 16px 20px;
  background: #111;
  border-top: 1px solid #2a2a2a;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.reply-content-cell { max-width: 180px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.del-btn-icon { background: none; border: none; color: #555; cursor: pointer; padding: 4px; }
.action-footer { margin-top: 12px; display: flex; gap: 8px; }
.action-btn-outline { flex: 1; background: none; border: 1px solid #333; color: #888; font-size: 11px; padding: 6px; border-radius: 4px; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 6px; }
.action-btn-outline:hover { border-color: #00d4ff; color: #00d4ff; }
.feature-center {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 5px 0 20px 0;
}
.standard-phone-screen {
  width: 100%;
  height: 100%;
  flex: 1;
  background: #000;
  position: relative;
  overflow: hidden;
}
.live-video-player { width: 100%; height: 100%; object-fit: cover; position: absolute; inset: 0; }
.live-bottom-area { margin-top: auto; padding: 12px; position: relative; }
.comment-gradient { position: absolute; bottom: 0; left: 0; width: 100%; height: 150px; background: linear-gradient(to top, rgba(0,0,0,0.8), transparent); z-index: -1; }
.comments-mock { display: flex; flex-direction: column; gap: 6px; }
.comment { background: rgba(0, 0, 0, 0.3); padding: 4px 10px; border-radius: 10px; font-size: 12px; color: #fff; width: fit-content; }
.comment span { color: #ffeb3b; font-weight: 700; margin-right: 4px; }
.ai-analysis-layer { position: absolute; inset: 0; pointer-events: none; }
.ai-target-pos { position: absolute; display: flex; flex-direction: column; align-items: flex-start; cursor: move; pointer-events: auto; }
.sticker-anchor-tag {
  font-size: 9px;
  color: #000000;
  font-weight: 600;
  opacity: 0.8;
  line-height: 1;
  margin-bottom: 2px;
}
.sticker-anchor-tag .sep {
  color: #fe2c55;
  margin-right: 1px;
}
.final-sticker-preview {
  padding: 4px 10px; background: rgba(255, 255, 255, 0.5); color: #000000;
  backdrop-filter: blur(4px); border-radius: 4px; font-weight: 700; font-size: 14px;
  display: flex; flex-direction: column; align-items: flex-start;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); border: 1px solid rgba(255, 255, 255, 0.2);
  user-select: none;
}
@keyframes float { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-3px); } }
.player-control-bar {
  position: absolute; bottom: 0; left: 0; width: 100%; height: 0; opacity: 0; overflow: hidden;
  background: rgba(26, 26, 26, 0.9); backdrop-filter: blur(10px); padding: 0 16px; display: flex; align-items: center; gap: 15px;
  border-top: 1px solid rgba(255,255,255,0.05); transition: all 0.3s; z-index: 60; pointer-events: auto;
}
.phone-frame:hover .player-control-bar { height: 60px; opacity: 1; padding: 10px 15px; }
.play-btn-mini { color: #00d4ff; cursor: pointer; display: flex; align-items: center; }
.progress-section { flex: 1; display: flex; flex-direction: column; gap: 6px; }
.progress-bar-wrap { height: 4px; background: rgba(255,255,255,0.1); border-radius: 2px; cursor: pointer; position: relative; }
.progress-fill { position: absolute; inset: 0 auto 0 0; background: #00d4ff; border-radius: 2px; box-shadow: 0 0 10px rgba(0,212,255,0.5); }
.time-info { display: flex; gap: 4px; font-size: 10px; color: #888; font-family: monospace; }
.volume-section { display: flex; align-items: center; gap: 8px; color: #888; }
.volume-slider-mini { width: 60px; height: 3px; -webkit-appearance: none; background: rgba(255,255,255,0.1); border-radius: 2px; outline: none; }
.volume-slider-mini::-webkit-slider-thumb { -webkit-appearance: none; width: 8px; height: 8px; background: #fff; border-radius: 50%; cursor: pointer; }
.label-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 4px; }
.value-tag { font-size: 11px; color: #00d4ff; background: rgba(0, 212, 255, 0.1); padding: 2px 6px; border-radius: 4px; }
.cyber-input-mini {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  padding: 6px 10px;
  color: #fff;
  font-size: 12px;
  width: 60px;
}
.input-with-unit {
  display: flex;
  align-items: center;
  gap: 8px;
}
.input-with-unit .unit {
  color: #888;
  font-size: 12px;
}
.cyber-textarea-mini {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  padding: 8px;
  color: #fff;
  font-size: 12px;
  width: 100%;
  resize: vertical;
  height: 380px;
  max-height: 380px;
}
.cyber-input-large {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  padding: 8px 12px;
  color: #fff;
  font-size: 13px;
  width: 100%;
}
.cyber-send-btn {
  background: linear-gradient(180deg, #00d4ff 0%, #00a8cc 100%);
  border: none;
  color: #000;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s;
}
.cyber-send-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 212, 255, 0.3);
}
.empty-tip {
  text-align: center;
  color: #666;
  font-size: 12px;
  padding: 40px;
}
.live-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.user-info-capsule {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(0, 0, 0, 0.5);
  padding: 6px 10px;
  border-radius: 20px;
}
.user-info-capsule .avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
}
.user-info-capsule .avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.user-info-capsule .meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.user-info-capsule .name {
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}
.user-info-capsule .stats {
  color: rgba(255, 255, 255, 0.8);
  font-size: 11px;
}
.user-info-capsule .follow {
  background: #fe2c55;
  color: #fff;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}
.viewer-tag {
  background: rgba(0, 0, 0, 0.5);
  padding: 4px 10px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.viewer-tag .val {
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}
.viewer-tag .lab {
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
}
.config-item {
  margin-bottom: 12px;
}
.config-item label {
  display: block;
  color: #b0b0b0;
  font-size: 12px;
  margin-bottom: 6px;
}
.config-row {
  display: flex;
  gap: 12px;
  margin-top: 8px;
}
</style>
